import { render, staticRenderFns } from "./rightPower.vue?vue&type=template&id=712b6ff8&scoped=true&"
import script from "./rightPower.vue?vue&type=script&lang=js&"
export * from "./rightPower.vue?vue&type=script&lang=js&"
import style0 from "./rightPower.vue?vue&type=style&index=0&id=712b6ff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b6ff8",
  null
  
)

export default component.exports